import React from 'react';
import { Row, Col } from 'antd';
import { getColor } from '../../utils';
import { RiskTask } from '@/core/domain/owas-report';
import * as S from './styles';

interface SeriousRiskTableProps {
	data: RiskTask[];
}

export function SeriousRiskTable({ data = [] }: SeriousRiskTableProps): JSX.Element {
	return (
		<div>
			<Row justify="center" align="middle">
				<Col span={24}>
					{data?.map((task) => (
						<S.StyledLineRowRisk key={task.id} justify="center" align="middle">
							<S.StyledLineColRisk span={2}>
								<div className="sequence">
									<h3>{task.sequence}</h3>
								</div>
							</S.StyledLineColRisk>
							<S.StyledLineColRisk span={20}>
								<h3 className="task-name">{task.name}</h3>
							</S.StyledLineColRisk>
							<S.StyledLineColRisk className="border-risk" color={getColor(task.score)} span={2}>
								<span>{task.score}</span>
							</S.StyledLineColRisk>
						</S.StyledLineRowRisk>
					))}
				</Col>
			</Row>
		</div>
	);
}
